import Class from '@/Class';

export default class DeferredQueue extends Class {

    private queue;
    private def;
    private callback;

    public length: number;

    constructor(timeout?: number) {
        super();

        this.queue = ko.observable([]).extend({ waiter: timeout || 50 });
        this.def = $.Deferred();
        this.callback = null;

        this.length = 0;

        this.defineSubscription(this.queue, (queue: any) => {
            for (let i = 0; i < queue.length; i++) {
                this.def = this.def.then(queue[i]);
            }

            this.def.then((result) => {
                if (this.callback) {
                    this.callback(result);
                }
            });

            this.def.resolve();
        });
    }

    public resolve() {
        this.enqueue((() => {}) as any);
    }

    public enqueue(newDeferred: JQueryDeferred<any> | JQueryPromise<any>) {
        let arr = this.queue().push(newDeferred);
        this.queue(arr);

        this.length++;

        return this;
    }

    public done(func: (result: any) => void) {
        this.callback = func;

        return this;
    }
}